/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 1:42 PM
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { __ } from 'wp.i18n';
import Row from './Row';

class ZipCodeNotFound extends Component {
	constructor( props ) {
		super( props );
	}

	componentDidCatch( error, info ) {
		console.log( error );
		console.log( info );
	}

	render() {
		if ( true === this.props.hasService || null === this.props.hasService ) {
			return null;
		}

		return (
			<Fragment>
				<Row>
					<div className={`col d-flex justify-content-center align-self-center`}>
						<div className={`noServiceIconContainer`}><i
							className={`dashicons dashicons-no noServiceIcon`} /></div>
						<p>{__( `Oops! It seems that we can't offer you a service in your area! Please try another city that is near to you!` )}</p>
					</div>
				</Row>
			</Fragment>
		);
	}
}

ZipCodeNotFound.propTypes = {
	hasService : PropTypes.bool
};

ZipCodeNotFound.defaultProps = {
	hasService : null
};

export default ZipCodeNotFound;
